import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DevToolsProtection = () => {
    const [enabled, setEnabled] = useState(false);

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const res = await axios.get(`${API}/settings`);
                setEnabled(res.data.devtools_protection);
            } catch {
                setEnabled(false);
            }
        };
        fetchSettings();
        const interval = setInterval(fetchSettings, 30000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (!enabled) return;

        const blockContextMenu = (e) => e.preventDefault();
        const blockKeys = (e) => {
            if (
                e.key === 'F12' ||
                (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'i')) ||
                (e.ctrlKey && e.shiftKey && (e.key === 'J' || e.key === 'j')) ||
                (e.ctrlKey && e.shiftKey && (e.key === 'C' || e.key === 'c')) ||
                (e.ctrlKey && (e.key === 'U' || e.key === 'u')) ||
                (e.ctrlKey && (e.key === 'S' || e.key === 's'))
            ) {
                e.preventDefault();
                e.stopPropagation();
            }
        };
        const blockDrag = (e) => {
            // Allow drag in exercise pages (scrambled word exercises)
            if (e.target.closest('[data-allow-drag]')) return;
            e.preventDefault();
        };
        const blockSelect = () => {
            document.body.style.userSelect = 'none';
            document.body.style.webkitUserSelect = 'none';
        };

        document.addEventListener('contextmenu', blockContextMenu);
        document.addEventListener('keydown', blockKeys);
        document.addEventListener('dragstart', blockDrag);
        blockSelect();

        return () => {
            document.removeEventListener('contextmenu', blockContextMenu);
            document.removeEventListener('keydown', blockKeys);
            document.removeEventListener('dragstart', blockDrag);
            document.body.style.userSelect = '';
            document.body.style.webkitUserSelect = '';
        };
    }, [enabled]);

    return null;
};

export default DevToolsProtection;
